import IpAddressWhitelistsPage from '@/pages/ip_address_whitelists';
import { r2wc } from '@/wc/helper/render';

export const IpAddressWhitelists = r2wc(IpAddressWhitelistsPage, {
  shadow: 'open',
  props: {
    officeId: 'string',
  },
});
